import React from 'react'
import './Styles.css';

function Header() {
  return (
    <div className='header'>
        <section>Welcome</section>
        <section>History</section>
        <section>Works</section>
        <section>About</section>
        <section>Contact</section>
    </div>
  )
}

export default Header
